import React, { ReactElement } from 'react';
import Card from '../card/card.component';
import NoContentBlock from '../no-content-block/no-content-block.component';
import FormatService from '../../services/format-service';
import useStylesSinglePageBlock from './single-page-block.styles';

const SinglePageBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isEmpty,
    isDark,
    isScrollable,
    isFullWidth,
    isFullHeight,
    withNoBackground,
    withNoTabsOffset,
    withNoPadding,
    children,
  } = props;

  const { classes } = useStylesSinglePageBlock();

  const darkClassName: string | undefined = isDark ? classes.singlePageBlockDark : undefined;
  const noTabsOffsetClassName: string | undefined = withNoTabsOffset ? classes.singlePageBlockNoTabsOffset : undefined;
  const scrollableClassName: string | undefined = isScrollable ? classes.singlePageBlockScrollable : undefined;
  const scrollableNoTabsOffsetClassName: string | undefined = isScrollable && withNoTabsOffset
    ? classes.singlePageBlockScrollableNoTabsOffset : undefined;
  const fullHeightClassName: string | undefined = isFullHeight ? classes.singlePageBlockFullHeight : undefined;

  return (
    <Card
      isFullWidth={isFullWidth}
      isContainer={!isEmpty}
      isFlat={withNoBackground}
      isScrollable={isScrollable}
      withNoPadding={withNoPadding}
      withNoBackground={withNoBackground}
      className={FormatService.formatClassNames(
        classes.singlePageBlock, darkClassName, noTabsOffsetClassName, scrollableClassName,
        scrollableNoTabsOffsetClassName, fullHeightClassName,
      )}
    >
      {
        !isEmpty ? (
          children
        ) : (
          <NoContentBlock isExtended>
            No data to display
          </NoContentBlock>
        )
      }
    </Card>
  );
});

export default SinglePageBlock;
